import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { RootSiblingParent } from 'react-native-root-siblings';
import AppStack from './AppStack';
import AgentStack from './AgentStack';
import { User } from './utils/types/Users';
import { connect } from 'react-redux';
import { RootState } from './redux';
import { Platform } from 'react-native';
import AdminStack from './AdminStack';

interface RootNavigatorProps {
	user: User;
}

function RootNavigator({ user }: RootNavigatorProps) {
	return (
		<RootSiblingParent>
			<NavigationContainer>
				{Platform.OS == 'web' ? <AdminStack /> : user.role == null ? <AppStack /> : <AgentStack />}
			</NavigationContainer>
		</RootSiblingParent>
	);
}

const mapStateToProps = (state: RootState) => {
	const { user } = state;
	return {
		user,
	};
};

export default connect(mapStateToProps)(RootNavigator);
